export default "__VITE_ASSET__BHoKZ$nX__"